export const STORAGEKEY = {
  token: 'token',
  authData: 'authData',
  userData: 'userData',
  layoutData: 'layoutData',
  socialAccData: 'socialAccData'
};

export const AppSettings = {
  defaultNavigation: '/dashboard'
};

export const AppUser = {
  entertainer: 'entertainer',
  person: 'person',
  admin: 'admin'
};
